import { adminApi } from './http';

const EXPIRES_AT_KEY = 'admin_session_expires_at';

export const clearAdminToken = () => {
  window.localStorage.removeItem(EXPIRES_AT_KEY);
  window.localStorage.removeItem('admin_token');
};

export const isAdminLoggedIn = () => {
  const expiresAt = Number(window.localStorage.getItem(EXPIRES_AT_KEY));

  if (!Number.isFinite(expiresAt) || Date.now() >= expiresAt) {
    clearAdminToken();
    return false;
  }

  return true;
};

export const loginAdmin = async (payload) => {
  clearAdminToken();
  const response = await adminApi.post('/auth/login', payload);
  const body = response.data || {};
  const data = body.data || body;
  const expiresIn = Number(data.expiresIn);

  if (!Number.isFinite(expiresIn) || expiresIn <= 0) {
    throw new Error('登录成功，但响应中没有找到有效期');
  }

  window.localStorage.setItem(EXPIRES_AT_KEY, String(Date.now() + expiresIn * 1000));
  return body;
};

export const sendAdminLoginCode = (payload) => adminApi.post('/auth/login-code', payload, {
  timeout: 60 * 1000,
  skipAdminUnauthorizedHandler: true,
});

export const logoutAdmin = async () => {
  try {
    await adminApi.post('/auth/logout');
  } finally {
    clearAdminToken();
  }
};

export const changeAdminPassword = (payload) => adminApi.put('/auth/password', payload, {
  skipAdminUnauthorizedHandler: true,
});

export const getAdminProfile = async () => {
  const response = await adminApi.get('/auth/profile');
  const body = response.data || {};
  return body.data || body;
};

export const updateAdminProfile = (payload) => adminApi.put('/auth/profile', payload);
